module.exports = __webpack_public_path__ + "static/img/facebook.47363ab4.png";